export default __webpack_public_path__ + "static/media/portfolio-168.6bacb33e.jpg";